import dayjs from "dayjs";
import { useCallback, useState } from "react";
import { TableState } from "react-table";

type TableStateType = Omit<
  TableState,
  | "rowCount"
  | "columnOrder"
  | "selectedRowIds"
  | "expanded"
  | "groupBy"
  | "columnResizing"
>;

const useTableState = (initialState?: TableStateType) => {
  const [tableState, setTableState] = useState<TableStateType>(
    initialState
      ? initialState
      : {
          sortBy: [{ desc: true, id: "createdAt" }],
          pageIndex: 0,
          pageSize: 10,
          filters: [],
          globalFilter: "",
        }
  );
  const [resetTableData, setResetTableData] = useState(false);
  const onFetchData = useCallback(
    async ({
      pageSize,
      pageIndex,
      sortBy,
      filters,
      globalFilter,
    }: TableState) => {
      console.log("FETCHING DATA", globalFilter);
      resetTableData ? setResetTableData(false) : null;
      setTableState((current) => {
        const newState = {
          ...current,
          pageSize,
          pageIndex,
          sortBy,
          filters,
          globalFilter: globalFilter?.toString(),
        };
        return newState;
      });
    },
    [resetTableData, tableState]
  );

  return {
    tableState,
    setTableState,
    onFetchData,
    resetTableData,
    setResetTableData,
  };
};

export { useTableState };
